import { Link } from 'react-router-dom';

export default function InfoBar() {
  const down=()=>document.getElementById('localizacao')?.scrollIntoView({behavior:'smooth'});
  return <section id="sobre" className="ys-infobar">
    <h2 className="ys-infobar-title">INFORMAÇÕES SOBRE A FESTA</h2>
    <div className="ys-info-item"><i className="ri-calendar-2-line"/><strong>12</strong><div><b>SET / 2026</b><span>SÁBADO<br/>ÀS 20H</span></div></div>
    <button className="ys-down" onClick={down} aria-label="Ir para localização"><i className="ri-arrow-down-s-line"/></button>
    <div className="ys-divider" />
    <div className="ys-info-item ys-address"><i className="ri-map-pin-line"/><div><b>BISUTTI ZERO ONZE</b><span>R. Alvorada, 1035<br/>Vila Olímpia – São Paulo / SP</span></div></div>
    <Link className="ys-more-button" to="/sobre-a-festa">VER MAIS <i className="ri-arrow-right-line" /></Link>
  </section>;
}
